<script setup lang="ts">
/*
 * @descriptions: 原始数据确认弹窗
 */
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import common from '@/utils/common'
import Cookies from 'js-cookie'

// router使用
const router = useRouter()

// 数据初始化
const dialogVisible = ref(false)

let panMajorbioVisible = Cookies.get('panMajorbioVisible')
const handleClose = () => {
  dialogVisible.value = false
  Cookies.set('panMajorbioVisible', '0')
}
const handleSure = () => {
  handleClose()
  router.push({ name: 'Task', query: { tp: 13 } }) // 跳转到我的事项，并且带参数：类型（原始数据确认）、状态（未处理）
}

// 父子数据传递
const $props = defineProps({
  closeVisible: {
    type: Boolean
  },
  mess: {
    type: String,
    default: '您的原始数据已发送给您，请您确认数据是否下载完成并且已完成备份！'
  },
  subMess: {
    type: String,
    default: '注：原始数据非常重要，会影响到您数据分析及文章发表'
  }
})

// 暴露组件的属性和方法
defineExpose({
  dialogVisible
})
</script>

<template>
  <el-dialog
    draggable
    :close-on-click-modal="false"
    v-model="dialogVisible"
    title="温馨提示"
    width="640"
    align-center
    :before-close="handleClose"
  >
    <div class="sure-tip flex">
      <img
        width="70px"
        height="70px"
        class="mr20"
        src="../../assets/images/common/pan_tips_img.png"
      />
      <div>
        <p>{{ $props.mess }}</p>
        <p class="red mt10">{{ $props.subMess }}</p>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer text-center">
        <el-button type="primary" @click="handleSure"> 立即前往确认 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped></style>
